import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { getLang, setLangGlobal } from "@/lib/i18n";

const FALLBACK = {
  announcement: "Now starting in Jaipur · More cities soon",
  announcement_enabled: true,
  hero_eyebrow: "Launching in Jaipur",
  hero_title: "Your local kabadiwala, just a tap away.",
  hero_subtitle: "Kindsaver connects homes, shops and offices with local kabadiwalas in your area.",
  consumer_cta_label: "Book a pickup",
  partner_cta_label: "I'm a kabadiwala",
  consumer_app_url: "https://app.kindsaver.com",
  partner_app_url: "https://app.kindsaver.com/partner",
  launch_city: "Jaipur",
  phone: "+91 99284 09292",
  whatsapp: "919928409292",
  email: "info@kindsaver.com",
  support_email: "support@kindsaver.com",
  address: "Malviya Nagar, Jaipur, Rajasthan",
  hours: "Mon–Sat · 9:00 AM – 7:00 PM",
  image_hero: "/images/hero-doorstep.jpg",
  image_home: "/images/sorting-home.jpg",
  image_kabadiwala: "/images/kabadiwala.jpg",
  image_about: "/images/hero-doorstep.jpg",
  faqs: [],
};

const SiteContext = createContext({ content: FALLBACK, reload: () => {}, lang: "en", setLang: () => {} });

export function SiteProvider({ children }) {
  const [content, setContent] = useState(FALLBACK);
  const [lang, setLangState] = useState(getLang());

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/content", { params: { lang } });
      setContent(data);
    } catch (_) { /* keep fallback */ }
  }, [lang]);

  useEffect(() => { document.documentElement.lang = lang; reload(); }, [reload, lang]);

  const setLang = (l) => { setLangGlobal(l); setLangState(l); };

  return <SiteContext.Provider value={{ content, reload, lang, setLang }}>{children}</SiteContext.Provider>;
}

export const useSite = () => useContext(SiteContext);
